<template>
  <AppContent
    v-bind="$props"
    v-on="$listeners"
    item-key="name"
    :form-dialog-props="{ maxWidth: 700 }"
    :table-props="{
      headers,
    }"
    @error-response="errorMessages = $event"
  >
    <template #table="{ attrs, on }">
      <AppTable v-bind="{ ...attrs, ...$props }" v-on="on">
        <template
          #item.action="slotProps"
          v-bind="{
            ...slotProps,
            on: {
              ...slotProps.on,
              ...tableItemSlotProps.on,
            },
          }"
        >
          <slot
            name="table.item.action"
            v-bind="{
              ...slotProps,
              on: {
                ...slotProps.on,
                ...tableItemSlotProps.on,
              },
            }"
          >
            <DeleteItemAction v-bind="slotProps" v-on="slotProps.on" />
          </slot>
        </template>
      </AppTable>
    </template>

    <template #formDialog="formDialogSlotProps">
      <AppFormDialog
        v-bind="formDialogSlotProps.attrs"
        v-on="formDialogSlotProps.on"
      >
        <template #form="slotProps">
          <LoanEligibleForm v-bind="slotProps"> </LoanEligibleForm>
        </template>
      </AppFormDialog>
    </template>
  </AppContent>
</template>

<script>
import AppContent from "./AppContent"
import AppTable from "./AppTable"
import AppFormDialog from "./AppFormDialog"
import LoanEligibleForm from "./employer/LoanEligibleForm"

import { DeleteItemAction } from "./base/table"

export default {
  name: "LoanEligible",

  components: {
    AppContent,
    AppTable,
    AppFormDialog,
    LoanEligibleForm,
    DeleteItemAction,
  },

  props: {
    resourcePath: {
      type: String,
      default: "loanEligibles",
    },
    title: {
      type: String,
      default: "Loan Eligible",
    },
    subject: {
      type: String,
      default: "Loan Eligible",
    },
    headers: {
      type: Array,
      default: function () {
        return [
          {
            text: "Id",
            value: "profile_id",
          },
          {
            text: "Name",
            value: "profile.full_name",
          },
          {
            text: "Description",
            value: "description",
          },
          {
            text: "Added by",
            value: "user.fullname",
          },
          {
            text: "Date Added",
            value: "created_at",
            align: "center",
          },
          {
            text: "Action",
            value: "action",
            align: "center",
            sortable: false,
            filterable: false,
          },
        ]
      },
    },
  },

  watch: {
    search(value) {
      console.log(value)
    },
  },

  data() {
    return {
      tableItemSlotProps: {
        on: {},
      },
    }
  },

  computed: {
    permissions() {
      return JSON.parse(localStorage.getItem("permissions"))
    },
  },
}
</script>
